var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tab-item",
    [
      _c(
        "v-layout",
        { attrs: { "justify-space-between": "" } },
        [
          _c(
            "v-flex",
            { attrs: { md2: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { dark: "", color: "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.showCommodityTemplateDialog()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                  _vm._v(_vm._s(_vm.$t("commodityTemplate")))
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md2: "" } },
            [
              _c("v-text-field", {
                staticClass: "text-xs-right",
                attrs: {
                  "append-icon": "filter_list",
                  label: _vm.$t("search"),
                  "single-line": "",
                  "hide-details": "",
                  clearable: ""
                },
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "my-1 elevation-2 myDense",
        attrs: {
          headers: _vm.commodityTemplateHeaders,
          items: _vm.commodityTemplates,
          "item-key": "key",
          "rows-per-page-items": _vm.rowPerPage,
          search: _vm.filter
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function(props) {
              return [
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v("\n        " + _vm._s(props.item.name) + "\n      ")
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(props.item.description || "-") +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _vm._l(props.item.commodities.slice(0, 3), function(
                      item,
                      index
                    ) {
                      return _c(
                        "v-chip",
                        { key: index, attrs: { small: "" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                item.customDescription ||
                                  item.scheduleBDescription ||
                                  _vm.$t("commodity")
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    props.item.commodities.length > 3
                      ? _c("span", { staticClass: "grey--text" }, [
                          _vm._v(
                            "\n          +" +
                              _vm._s(props.item.commodities.length - 3) +
                              " " +
                              _vm._s(_vm.$t("more")) +
                              "\n        "
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { dark: "", flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.showCommodityTemplateDialog(
                                      props.item
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("edit")))]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { dark: "", flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.deleteCommodityTemplate(
                                      props.item
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("delete")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.createCommodityTemplateDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title:
                (_vm.isEdit ? _vm.$t("edit") : _vm.$t("add")) +
                " " +
                _vm.$t("commodityTemplate"),
              large: "",
              rightMethod: _vm.submit,
              rightButtonText: _vm.$t("submit")
            },
            on: { popupClose: _vm.closeDialog },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("name"),
                                      rules: [
                                        _vm.fieldIsRequired(_vm.$t("name")),
                                        _vm.isTemplateNameUnique
                                      ]
                                    },
                                    model: {
                                      value: _vm.template.name,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.template,
                                          "name",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "template.name"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md8: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { label: _vm.$t("description") },
                                    model: {
                                      value: _vm.template.description,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.template,
                                          "description",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "template.description"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider", { staticClass: "my-3" }),
                          _vm._v(" "),
                          _c("v-subheader", [
                            _vm._v(_vm._s(_vm.$t("commodities")))
                          ]),
                          _vm._v(" "),
                          _vm.commodityErrorMessage
                            ? _c(
                                "v-layout",
                                {
                                  staticClass:
                                    "red--text font-weight-bold text-xs-right"
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.commodityErrorMessage) +
                                      "\n        "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-data-table", {
                            staticClass: "elevation-2 mt-2",
                            attrs: {
                              headers: _vm.commodityHeaders,
                              items: _vm.template.commodities,
                              "hide-actions": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "headerCell",
                                  fn: function(props) {
                                    return [
                                      props.header.value === "action"
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(tooltip) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              _vm._g(
                                                                {},
                                                                tooltip.on
                                                              ),
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      color:
                                                                        "primary",
                                                                      flat: "",
                                                                      small: "",
                                                                      icon: ""
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.addEmptyCommodity
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "add"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(_vm.$t("add")) +
                                                      "\n              "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _c("span", [
                                            _vm._v(_vm._s(props.header.text))
                                          ])
                                    ]
                                  }
                                },
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "tr",
                                        { staticClass: "commodity-row" },
                                        [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "error",
                                                                    flat: "",
                                                                    small: "",
                                                                    icon: "",
                                                                    disabled:
                                                                      _vm
                                                                        .template
                                                                        .commodities
                                                                        .length ===
                                                                      1
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.deleteCommodity(
                                                                        props.index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "delete"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("delete"))
                                                    )
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _c(
                                                "v-layout",
                                                { attrs: { row: "" } },
                                                [
                                                  _c("v-autocomplete", {
                                                    staticClass: "table-item",
                                                    staticStyle: {
                                                      "max-width": "200px"
                                                    },
                                                    attrs: {
                                                      value:
                                                        props.item
                                                          .selectedCommodity,
                                                      items:
                                                        _vm.mergedCommoditiesList,
                                                      "item-text":
                                                        "scheduleBDescription",
                                                      "item-value":
                                                        "scheduleBDescription",
                                                      filter:
                                                        _vm.customCommodityFilter,
                                                      clearable: "",
                                                      label: _vm.$t(
                                                        "commodity"
                                                      ),
                                                      placeholder: _vm.$t(
                                                        "commodities"
                                                      ),
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          _vm.$t("commodity")
                                                        )
                                                      ],
                                                      "return-object": ""
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.onComboboxChangeByCommodities(
                                                          $event,
                                                          props.index
                                                        )
                                                      },
                                                      input: function($event) {
                                                        return _vm.onComboboxChangeByCommodities(
                                                          $event,
                                                          props.index
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "item",
                                                          fn: function(data) {
                                                            return [
                                                              _c(
                                                                "v-list-tile-content",
                                                                {
                                                                  staticStyle: {
                                                                    "max-width":
                                                                      "300px",
                                                                    "white-space":
                                                                      "normal"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-tile-title",
                                                                    {
                                                                      staticStyle: {
                                                                        "white-space":
                                                                          "normal",
                                                                        "word-wrap":
                                                                          "break-word"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          data
                                                                            .item
                                                                            .scheduleBDescription ||
                                                                            data
                                                                              .item
                                                                              .description
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-list-tile-sub-title",
                                                                    {
                                                                      staticStyle: {
                                                                        "white-space":
                                                                          "normal",
                                                                        "word-wrap":
                                                                          "break-word"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                          Code: " +
                                                                          _vm._s(
                                                                            data
                                                                              .item
                                                                              .scheduleBCode
                                                                          ) +
                                                                          "\n                        "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        },
                                                        {
                                                          key: "no-data",
                                                          fn: function() {
                                                            return [
                                                              _c(
                                                                "v-list-tile",
                                                                [
                                                                  _c(
                                                                    "v-list-tile-content",
                                                                    [
                                                                      _c(
                                                                        "v-list-tile-title",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                            " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "noDataAvailable"
                                                                                )
                                                                              ) +
                                                                              "\n                          "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-text-field", {
                                                    staticClass: "table-item",
                                                    staticStyle: {
                                                      "max-width": "250px"
                                                    },
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "description"
                                                      ),
                                                      placeholder: _vm.$t(
                                                        "description"
                                                      ),
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          _vm.$t("description")
                                                        ),
                                                        _vm.fieldCharLimit(
                                                          "description",
                                                          35
                                                        )
                                                      ]
                                                    },
                                                    model: {
                                                      value:
                                                        props.item
                                                          .scheduleBDescription,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "scheduleBDescription",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.scheduleBDescription"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _c(
                                                "v-layout",
                                                { attrs: { row: "" } },
                                                [
                                                  _c("v-autocomplete", {
                                                    staticClass: "table-item",
                                                    attrs: {
                                                      items:
                                                        _vm.countryCodeArray,
                                                      label: _vm.$t(
                                                        "countryOfOrigin"
                                                      ),
                                                      "item-text": "name",
                                                      "item-value": "value",
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          _vm.$t(
                                                            "countryOfOrigin"
                                                          )
                                                        )
                                                      ]
                                                    },
                                                    model: {
                                                      value:
                                                        props.item
                                                          .countryOfOrigin,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "countryOfOrigin",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.countryOfOrigin"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-text-field", {
                                                    staticClass: "table-item",
                                                    class: {
                                                      required_field: _vm.isHsCodeRequired(
                                                        props.item
                                                      )
                                                    },
                                                    attrs: {
                                                      rules: [
                                                        _vm.validateHsCode
                                                      ]
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.onHarmonizedCodeInput(
                                                          props.item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        props.item
                                                          .harmonizedCode,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "harmonizedCode",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.harmonizedCode"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _c(
                                                "v-text-field",
                                                {
                                                  staticClass:
                                                    "required_field table-item qty_unit_filed",
                                                  attrs: {
                                                    rules: [
                                                      _vm.fieldIsRequired(),
                                                      _vm.fieldIsInteger(),
                                                      _vm.fieldIsOverZero()
                                                    ],
                                                    label: _vm.$t("quantity")
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return _vm.onQuantityInput(
                                                        props.item
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: props.item.quantity,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        props.item,
                                                        "quantity",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "props.item.quantity"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "append-outer" },
                                                    [
                                                      _c("v-autocomplete", {
                                                        staticClass:
                                                          "qty_unit required_field",
                                                        attrs: {
                                                          items:
                                                            _vm.inShowChannelUnionList,
                                                          rules: [
                                                            _vm.fieldIsRequired(
                                                              _vm.$t("unit")
                                                            )
                                                          ],
                                                          "item-text": "text",
                                                          "item-value": "key",
                                                          label: _vm.$t("unit")
                                                        },
                                                        model: {
                                                          value:
                                                            props.item
                                                              .selectedUnit,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              props.item,
                                                              "selectedUnit",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "props.item.selectedUnit"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.hasCommodityQty2
                                            ? _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm.isShowQty2(props.item)
                                                    ? _c(
                                                        "v-text-field",
                                                        {
                                                          staticClass:
                                                            "required_field table-item qty_unit_filed",
                                                          attrs: {
                                                            rules: [
                                                              _vm.fieldIsRequired(),
                                                              _vm.fieldIsInteger(),
                                                              _vm.fieldIsOverZero()
                                                            ],
                                                            label: _vm.$t(
                                                              "quantity"
                                                            )
                                                          },
                                                          model: {
                                                            value:
                                                              props.item
                                                                .quantity2,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                props.item,
                                                                "quantity2",
                                                                _vm._n($$v)
                                                              )
                                                            },
                                                            expression:
                                                              "props.item.quantity2"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            {
                                                              slot:
                                                                "append-outer"
                                                            },
                                                            [
                                                              _c(
                                                                "v-autocomplete",
                                                                {
                                                                  staticClass:
                                                                    "qty_unit required_field",
                                                                  attrs: {
                                                                    items:
                                                                      _vm.inShowUnit2List,
                                                                    rules: [
                                                                      _vm.fieldIsRequired(
                                                                        _vm.$t(
                                                                          "unit"
                                                                        )
                                                                      )
                                                                    ],
                                                                    "item-text":
                                                                      "text",
                                                                    "item-value":
                                                                      "key",
                                                                    label: _vm.$t(
                                                                      "unit"
                                                                    )
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      props.item
                                                                        .quantity2Units,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        props.item,
                                                                        "quantity2Units",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "props.item.quantity2Units"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !_vm.isShowQty2(props.item)
                                                    ? _c(
                                                        "v-text-field",
                                                        {
                                                          staticClass:
                                                            "required_field pt-0 table-item qty_unit_filed",
                                                          attrs: {
                                                            rules: [
                                                              _vm.fieldIsRequired(),
                                                              _vm.fieldIsInteger(),
                                                              _vm.fieldIsOverZero()
                                                            ],
                                                            label: _vm.$t(
                                                              "quantity"
                                                            ),
                                                            disabled: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            {
                                                              slot:
                                                                "append-outer"
                                                            },
                                                            [
                                                              _c(
                                                                "v-autocomplete",
                                                                {
                                                                  staticClass:
                                                                    "qty_unit required_field",
                                                                  attrs: {
                                                                    items:
                                                                      _vm.inShowUnit2List,
                                                                    rules: [
                                                                      _vm.fieldIsRequired(
                                                                        _vm.$t(
                                                                          "unit"
                                                                        )
                                                                      )
                                                                    ],
                                                                    "item-text":
                                                                      "text",
                                                                    "item-value":
                                                                      "key",
                                                                    disabled:
                                                                      "",
                                                                    label: _vm.$t(
                                                                      "unit"
                                                                    )
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _c("v-text-field", {
                                                staticClass:
                                                  "table-item required_field",
                                                attrs: {
                                                  label: _vm.$t("price"),
                                                  prefix: "$",
                                                  rules: [
                                                    _vm.fieldIsOverZero(
                                                      _vm.$t("price")
                                                    )
                                                  ]
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.onPriceInput(
                                                      props.item
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: props.item.price,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      props.item,
                                                      "price",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression: "props.item.price"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _c("v-text-field", {
                                                staticClass:
                                                  "table-item required_field",
                                                attrs: {
                                                  label: _vm.$t("customsValue"),
                                                  value:
                                                    props.item.customsValue,
                                                  prefix: "$",
                                                  disabled: true
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _c("v-text-field", {
                                                staticClass:
                                                  "table-item required_field",
                                                attrs: {
                                                  label: _vm.$t("weight"),
                                                  suffix: _vm.isMeasurementMetric
                                                    ? "kg"
                                                    : "Lbs",
                                                  rules: [
                                                    _vm.fieldIsOverZero(
                                                      _vm.$t("weight")
                                                    )
                                                  ]
                                                },
                                                model: {
                                                  value:
                                                    props.item.commodityWeight,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      props.item,
                                                      "commodityWeight",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "props.item.commodityWeight"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2883750583
                            )
                          })
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              355082953
            ),
            model: {
              value: _vm.createCommodityTemplateDialog,
              callback: function($$v) {
                _vm.createCommodityTemplateDialog = $$v
              },
              expression: "createCommodityTemplateDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9f604f04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f604f04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommodityTemplateTab.vue
// module id = null
// module chunks = 